import { onAuthStateChanged } from "firebase/auth";
import HTMLReactParser from "html-react-parser";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getShowsById, ShowDetailType } from "../api";
import { auth } from "../firebase";

const Detail = () => {
  const [show, setShow] = useState({} as ShowDetailType);
  const navigate = useNavigate();
  const { showId } = useParams();

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (!user) navigate("/login");
      else {
        const show = await getShowsById(Number(showId));
        if (show) setShow(show);
      }
    });
  }, []);

  return (
    <>
      <figure className="p-12">
        <img
          className="w-40 rounded-xl mx-auto"
          src={show.image}
          alt=""
          width="384"
          height="512"
        />
        <div className="pt-10 md:p-8 text-center md:text-left space-y-4">
          <div>
            <p className="text-3xl font-bold dark:text-slate-200">{show.title}</p>
            <div className="text-base font-base dark:text-slate-400 pt-5">
              {HTMLReactParser(show.summary || "")}
            </div>
          </div>
          <figcaption className="font-medium">
            <div className="text-sky-500 dark:text-sky-400">
              {show.startDate} {show.endDate ? "/ " + show.endDate : ""}
            </div>
            <div className="text-slate-500 dark:text-slate-500">
              {show.genres}
            </div>
          </figcaption>
        </div>
      </figure>
    </>
  );
};

export default Detail;
